import { cx } from 'cva';
import { type FunctionComponent } from 'react';
import { Link } from '../../../../../../atoms/Link/Link';
import { ChevronRightIcon } from '../../../../../../icons/ChevronRightIcon';
import styles from './QuickLink.module.css';

export type QuickLink = {
  className?: string;
  path: string;
  title: string;
};

export const QuickLink: FunctionComponent<QuickLink> = ({
  className,
  path,
  title,
}) => {
  return (
    <div className={styles.root}>
      <Link className={cx(styles.link, className)} href={path}>
        <div>{title}</div>
        <ChevronRightIcon className={styles.chevron} />
      </Link>
    </div>
  );
};
